import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative min-h-[600px] md:min-h-[800px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/edited_2a92ade85170481fa72f5ff85e39fac7_2c06ac4d.jpg"
          alt="得運智科企業顧問背景"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-primary-900/35 via-primary-900/20 to-primary-900/45" />
      </div>

      <div className="relative z-10 w-full px-4 md:px-6 lg:px-8 text-center pt-20">
        <h1 className="text-3xl md:text-5xl lg:text-6xl font-bold text-white leading-tight mb-6 max-w-5xl mx-auto">
          連結產官學資源
          <br />
          <span className="text-2xl md:text-4xl lg:text-5xl font-medium">
            讓企業升級不再單打獨鬥
          </span>
        </h1>
        <p className="text-sm md:text-lg text-white/90 max-w-3xl mx-auto mb-10 leading-relaxed lg:max-w-4xl">
          得運智科股份有限公司整合政府輔導資源、AI 應用導入、財稅管理、ESG 永續與產學技術能量，<br /><span className="lg:whitespace-nowrap">協助企業從診斷、規劃、申請、導入到落地執行，打造更穩健、更智慧、更具競爭力的成長路徑。</span>
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link
            to="/contact"
            className="bg-white text-primary-900 px-8 py-4 rounded-full text-base font-semibold hover:bg-accent-500 hover:text-white transition-colors duration-200 whitespace-nowrap shadow-lg shadow-black/20"
          >
            立即預約諮詢
          </Link>
          <Link
            to="/services"
            className="border-2 border-white text-white px-8 py-4 rounded-full text-base font-semibold hover:bg-white hover:text-primary-900 transition-colors duration-200 whitespace-nowrap"
          >
            了解服務項目
          </Link>
        </div>
      </div>
    </section>
  );
}